<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="50%"
      class="dialog"
      center
    >
      <div class="contents">
        <el-form
          class="demo-cityForm"
          label-width="170px"
          ref="refCityForm"
          :model="cityForm"
        >
          <el-form-item>
            <el-radio-group v-model="cityForm.is_premiums_deduction">
              <el-radio :label="1">扣费</el-radio>
              <el-radio :label="0">不扣费</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="截止时间"
            v-if="cityForm.is_premiums_deduction == 0"
          >
            <el-date-picker
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
              v-model="cityForm.premiums_deduction_deadline_date"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">取 消</el-button>
        <el-button
          type="primary"
          :disabled="submitLoading"
          @click="onHandleSubmit"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "insuranceDialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "",
      submitLoading: false,
      pickerOptions: {
        disabledDate(time) {
          // time 是当前遍历到的日期，格式为 Date 对象
          // 通过 setHours(0, 0, 0, 0) 将时间部分置零，只比较日期
          return time.getTime() < new Date().setHours(0, 0, 0, 0);
        }
      },
      cityFormClone: {},
      cityForm: {
        is_premiums_deduction: "",
        premiums_deduction_deadline_date: "",
        id: "",
      },
    };
  },
  methods: {
    onInitData(data) {
      console.log(data, "data===");
      this.dialogVisible = true;
      this.dialogTitle =
        data.name +
        `${data.is_premiums_deduction == 1 ? "保险扣款" : "保险配置"}`;
      this.cityForm = {
        is_premiums_deduction: data.is_premiums_deduction,
        id: data.id,
        premiums_deduction_deadline_date: data.premiums_deduction_deadline_date,
      };
      this.cityFormClone = cloneDeep(this.cityForm);
      this.$refs.refCityForm?.clearValidate();
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.cityForm = {
        ...this.cityFormClone,
      };
      this.$refs.refCityForm?.clearValidate();
      this.dialogVisible = false;
    },

    /**
     * 确认
     */
    onHandleSubmit() {
      this.$refs.refCityForm.validate((valid) => {
        this.submitLoading = true;
        if (this.cityForm.is_premiums_deduction == 1) {
          this.cityForm.premiums_deduction_deadline_date = "";
        }
        this.$api.insurance
          .deductinsurance(this.cityForm)
          .then((res) => {
            this.$message({
              type: "success",
              message: "切换成功!",
            });
            this.dialogVisible = false;
            this.$emit('insurance',true)
          })
          .finally((e) => {
            this.submitLoading = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.insurance-dialog {
  width: 80%;
}
</style>
